/** Stable fallbacks for zustand selectors — avoid `|| {}` creating new refs every render. */
export const STABLE_EMPTY_OBJECT: Record<string, never> = Object.freeze({});
export const STABLE_EMPTY_ARRAY: never[] = Object.freeze([]) as never[];
